import {
  type AllInstructionsData,
  GENERATION_MODE_TYPE,
  type GenerationModeType,
} from 'src/data/generation';
import { withoutServiceGenerationModes } from 'src/data/utils';
import type { ID } from 'src/lib/collection';

import type { GenerationTool } from './const';
import { getToolGenerationModes } from './toolGenerationModes';
import { getToolMixtureSubGenerationTools } from './toolProps';

export interface SubGenerationToolProps {
  selectedModeId?: ID;
  selectedModeType?: GenerationModeType;
  visibleDDTemplates?: string[];
  errors?: Record<string, string>;
  generationTool?: GenerationTool;
  subGenerationTool?: GenerationTool;
  structureInstructionsData?: AllInstructionsData;
}

type MultiPromptSubGenerationToolProps = Record<string, SubGenerationToolProps>;

export const initMultiPromptSubGenerationToolProps = (
  generationTool: GenerationTool
): MultiPromptSubGenerationToolProps => {
  const subGenerationTools = getToolMixtureSubGenerationTools(generationTool);
  if (!subGenerationTools) {
    return {};
  }

  const result: MultiPromptSubGenerationToolProps = {};
  subGenerationTools.forEach((subGenerationTool) => {
    const availableTemplates = getToolGenerationModes(subGenerationTool);
    const visibleTemplates = withoutServiceGenerationModes(availableTemplates);

    const selectedModeId = visibleTemplates[0];
    const selectedModeType = GENERATION_MODE_TYPE.common;

    result[subGenerationTool] = {
      selectedModeId,
      selectedModeType,
      visibleDDTemplates: visibleTemplates,
      errors: {},
      generationTool: subGenerationTool,
      subGenerationTool,
    };
  });
  return result;
};
